import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';
import Config from 'src/common/Config';
import useFlagOverrides from './useFlagOverrides';

export type Flags = {
  showDataUploadCounts: boolean;
  flagEnabledLexicalEditor: boolean;
  flagEnabledRemoveDynamicUi: boolean;
  flagEnabledComplianceChecking: boolean;
  flagEnabledDocumentEdit: boolean;
  flagEnabledMeetingNoteFromAgenda: boolean;
  flagEnabledNewSuitabilityReportAccess: boolean;
  flagEnabledNewSuitabilitySiestaBar: boolean;
  flagEnabledCustomSettingsFlow: boolean;
  flagEnabledMeetingNoteSummarisation: boolean;
  flagEnabledMobileLoginPage: boolean;
  flagEnabledMaintenanceMode: boolean;
  flagEnabledNewSuitabilityReviewedState: boolean;
  flagEnabledCompanyDocumentsAppendices: boolean;
  flagEnabledFactFindSelfService: boolean;
  flagEnabledClientDocumentEmail: boolean;
  flagEnabledMeetingNoteFromDocument: boolean;
  flagEnabledMeetingNoteEdit: boolean;
  flagEnabledNewLayout: boolean;
  flagEnabledBotMigration: boolean;
  flagEnabledTranscriptionOnClientCreation: boolean;
  flagEnabledBulkValControlCentre: boolean;
  flagEnabledMeetingNoteCitations: boolean;
  flagEnabledSiestaSteering: boolean;
};

export function useFlags(): Flags {
  const ldFlags = useLDFlags<Flags>();
  const { overrides } = useFlagOverrides();
  if (!Config.isDev()) return ldFlags;
  return { ...ldFlags, ...overrides };
}
